import { jsx as _jsx } from "react/jsx-runtime";
var StarO = function StarO(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1.0625 * size,
    height: size,
    viewBox: "0 0 34 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M33.4 11.35l-10.45-1.5-4.7-9.2c-0.3-0.6-1-0.8-1.6-0.5-0.2 0.1-0.4 0.3-0.5 0.5l-4.65 9.25-10.5 1.45c-0.45 0.050-0.8 0.35-0.95 0.8-0.15 0.4 0 0.9 0.3 1.2l7.6 7.15-1.8 10.15c-0.1 0.45 0.1 0.85 0.45 1.1s0.85 0.3 1.25 0.1l9.35-4.8 9.35 4.8c0.4 0.2 0.85 0.15 1.25-0.1 0.35-0.25 0.55-0.7 0.45-1.1l-0.75-4.2-1-5.95 7.55-7.2c0.3-0.3 0.45-0.75 0.3-1.2-0.15-0.4-0.5-0.7-0.95-0.75zM25.15 20.050l1.15 6.55 0.8 4.1-9.9-5-9.85 5.2 1.9-10.8-8.1-7.5 11.15-1.6 4.9-9.8 4.95 9.8 11.1 1.4-8.1 7.65z"
    })
  });
};
export default StarO;